import { useCallback, useEffect, useState } from "react";
import type { PublicProposalData } from "../../shared/types";
import { ProposalLock, ProposalView } from "../components/ProposalView";
import { VisitTracking } from '../components/VisitTracking';

interface LockedData { clientName: string; title: string; accent: string }

export function PublicPage({ slug }: { slug: string }) {
  const [data, setData] = useState<PublicProposalData | null>(null);
  const [locked, setLocked] = useState<LockedData | null>(null);
  const [error, setError] = useState("");
  const load = useCallback(async () => {
    setError("");
    const response = await fetch(`/api/public/${slug}`);
    const payload = await response.json().catch(() => ({})) as PublicProposalData & LockedData & { error?: string; locked?: boolean };
    if (response.status === 401 && payload.locked) {
      setLocked({ clientName: payload.clientName, title: payload.title, accent: payload.accent });
      return;
    }
    if (!response.ok) {
      setError(response.status === 404 ? "This proposal is not available." : payload.error ?? "Could not load this proposal.");
      return;
    }
    setLocked(null);
    setData(payload);
    document.title = `${payload.proposal.title} | Leviathan`;
  }, [slug]);
  useEffect(() => { void load(); }, [load]);
  if (error) return <main className="not-found"><div><span>404</span><h1>Proposal unavailable.</h1><p>{error}</p><a href="mailto:jb@lvthn.co">Contact Leviathan</a></div></main>;
  if (!data && !locked) return <div className="public-loading"><span className="brand-mark"><span /></span><p>Opening proposal…</p></div>;
  return <><VisitTracking key={slug} slug={slug} stage={locked ? 'locked' : 'opened'} />{locked ? <ProposalLock {...locked} slug={slug} onUnlocked={() => void load()} /> : data && <ProposalView {...data} onAccepted={(acceptedAt, acceptedQuote) => setData({ ...data, proposal: { ...data.proposal, status: 'accepted', acceptedAt, acceptedQuote } })} />}</>;
}
